import React from 'react';
import { StickyHeader } from 'app/components/matchCalendar/stickyHeader';
import CompetitionMatchdayList from 'app/components/matchCalendar/CompetitionMatchdayList';
import { StreamPlaceholder } from 'app/styles/stream';
import { LOADING_MESSAGE, LoadingIndicator } from '@fupa/fupa-uikit';
export default function ProCompetitionMatchdays(_ref) {
  let {
    items,
    isFetching,
    isError
  } = _ref;
  const showPros = items !== null && items !== void 0 && items.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StickyHeader, {
    title: 'Profis'
  }), /*#__PURE__*/React.createElement(CompetitionMatchdayList, {
    data: items
  })) : null;
  const showLoadingPro = isFetching ? /*#__PURE__*/React.createElement(LoadingIndicator, {
    bgColor: true,
    message: LOADING_MESSAGE.loadingMatches
  }) : null;
  const showProMatchesError = isError ? /*#__PURE__*/React.createElement(StreamPlaceholder, null, "Beim Laden der Profi-Spiele ist ein Fehler aufgetreten.") : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, showPros, showLoadingPro, showProMatchesError);
}